import { Component } from '@angular/core';
import { DateFilterDialogService } from './date-filter.service.dialog';
import { FilterService } from 'src/app/services/filter.service';

@Component({
  selector: 'ap-date-filter-dialog',
  templateUrl: 'date-filter.dialog.html',
  styleUrls: ['./date-filter.dialog.scss']
})
export class DateFilterDialogComponent {

  constructor(
    public dateFilterService: DateFilterDialogService
    ) {}


  apply(start: Date, end: Date) {

    let dateQuery: any = {};

    if (start != null) {
      dateQuery["$gte"] = start;
    }

    if (end != null) {
      dateQuery["$lte"] = end;
    }

    this.dateFilterService.apply(dateQuery);
  }

  financialYear(start: string, end: string) {
    this.apply(new Date(start), new Date(end));
  }

  thisWeek() {
    let curr = new Date; // get current date
    let first = curr.getDate() - curr.getDay()+1; // First day is the day of the month - the day of the week
    let last = first + 6; // last day is the first day + 6
    

    let firstDay = new Date(curr.setDate(first));
    let lastDay = new Date(curr.setDate(last));

    // reset time
    firstDay.setHours(0,0,0);
    lastDay.setHours(0,0,0);

    this.apply(firstDay, lastDay);
  }

  lastWeek() {
    let curr = new Date; // get current date
    let first = curr.getDate() - curr.getDay()+1; // First day is the day of the month - the day of the week
    let last = first + 6; // last day is the first day + 6
    
    first -= 7;
    last -= 7;

    let firstDay = new Date(curr.setDate(first));
    let lastDay = new Date(curr.setDate(last));

    // reset time
    firstDay.setHours(0,0,0);
    lastDay.setHours(0,0,0);

    this.apply(firstDay, lastDay);
  }

  thisMonth() {
    let date = new Date();
    this.apply(new Date(date.getFullYear(), date.getMonth(), 1), new Date(date.getFullYear(), date.getMonth()+1, 0))
  }

}
